module.exports = __webpack_public_path__ + "693c462a6c28b457ee8f954dc68f66eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/message_saved.png
// module id = 42
// module chunks = 0 1 2 3 4